import React from 'react';
import PropTypes from 'prop-types';
import { ModalHeader, ModalBody, ModalFooter, ModalNext } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { WMICButton } from 'wmic-pe-components-platform-react';
import { MODAL_CONSTANTS } from 'wmic-pe-portals-utils-js';

import messages from './WMICValidationMessageModal.messages';

const { STATUS, ICON } = MODAL_CONSTANTS;

const WMICValidationMessageModal = ({
    isOpen,
    onResolve,
    title = messages.actionRequired,
    message,
    icon = ICON.WARNING,
    status = STATUS.WARNING,
}) => {
    const translator = useTranslator();

    return (
        <ModalNext isOpen={isOpen} onRequestClose={onResolve} status={status}>
            <ModalHeader icon={icon} title={translator(title)} status={status} />
            <ModalBody>{translator(message)}</ModalBody>
            <ModalFooter>
                <WMICButton onClick={onResolve}>{translator(commonMessages.close)}</WMICButton>
            </ModalFooter>
        </ModalNext>
    );
};

WMICValidationMessageModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onResolve: PropTypes.func.isRequired,
    title: PropTypes.shape({
        id: PropTypes.string.isRequired,
        defaultMessage: PropTypes.string.isRequired,
    }),
    message: PropTypes.shape({
        id: PropTypes.string.isRequired,
        defaultMessage: PropTypes.string.isRequired,
    }).isRequired,
    icon: PropTypes.string,
    status: PropTypes.string,
};

export default WMICValidationMessageModal;
